var d="\nvoid occludeDiffuse() {\n    dDiffuseLight *= dAo;\n}\n";export{d as default};
